import React, { Component } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const generateAvatarurl = process.env.REACT_APP_GENERATE_AVATAR_URL;
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;

class CustomSlide extends Component {
  render() {
    const { children, ...props } = this.props;
    return <div {...props}>{children}</div>;
  }
}

export default class Responsive extends Component {
  state = {
    collections: [],
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.fetchCollections();
  }

  async fetchCollections() {
    try {
      const res = await axios.get(`${domainpath}/api/art//hot-collections`);
      if (res.data.success) {
        this.setState({ collections: res.data.collections, loading: false });
      } else {
        this.setState({ error: "Failed to load collections", loading: false });
      }
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  generateAvatar = (walletAddress) => {
    return `${generateAvatarurl}/${walletAddress}.png?size=200x200`;
  };

  renderCollectionCard = (col, idx = 0) => {
    const mainNFT = col.mainCollectionNFT || {};
    const imageUrl =
      mainNFT.ipfs_url?.replace("ipfs://", "https://ipfs.io/ipfs/") ||
      "./img/collections/default.jpg";
    const authorImg =
      col.ownerProfileImage || this.generateAvatar(mainNFT?.owner);

    return (
      <CustomSlide key={col.key || idx} className="itm" index={idx + 1}>
        <div className="nft_coll">
          <div className="nft_wrap">
            <span>
              <img
                src={imageUrl}
                className="lazy img-fluid h-60 w-full transition-transform duration-300 ease-in-out group-hover:scale-105"
                alt={mainNFT.name || col.value.description || "Collection"}
                onClick={() =>
                  (window.location.href = `/collection/${col.key || col.id}`)
                }
              />
            </span>
          </div>
          <div className="nft_coll_pp">
            <span
              onClick={() =>
                window.open(`/collection/${col.key || col.id}`, "_self")
              }
            >
              <img className="lazy" src={authorImg} alt="author" />
            </span>
            <i className="fa fa-check"></i>
          </div>
          <div className="nft_coll_info">
            <span
              onClick={() =>
                window.open(`/collection/${col.key || col.id}`, "_self")
              }
            >
              <h4>
                {mainNFT.name || col.value.description || "Unnamed Collection"}
              </h4>
            </span>
            <span>{mainNFT.name}</span>
          </div>
        </div>
      </CustomSlide>
    );
  };

  render() {
    const { collections, loading, error } = this.state;

    // const settings = {
    //   infinite: collections.length > 1,
    //   speed: 500,
    //   slidesToShow: Math.min(4, collections.length),
    //   slidesToScroll: 1,
    //   initialSlide: 0,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: Math.min(4, collections.length),
    //         slidesToScroll: 4,
    //         infinite: collections.length > 1,
    //       },
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         slidesToShow: 4,
    //         slidesToScroll: 1,
    //         infinite: false,
    //         dots: true,
    //       },
    //     },
    //   ],
    // };
    const settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        { breakpoint: 1900, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 1600, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1, slidesToScroll: 1, dots: false },
        },
      ],
    };
    if (loading) {
      return (
        <div className="nft grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 px-4">
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <div key={i} className="bg-gray-200 rounded-lg p-4 animate-pulse">
                <div className="h-40 bg-gray-300 rounded mb-4"></div>
                <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-300 rounded w-1/2"></div>
              </div>
            ))}
        </div>
      );
    }

    if (error) return <div>Error: {error}</div>;

    return (
      <div className="nft ">
        {collections.length === 1 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {this.renderCollectionCard(collections[0])}
          </div>
        ) : (
          <Slider {...settings}>
            {collections.map((col, idx) => this.renderCollectionCard(col, idx))}
          </Slider>
        )}
      </div>
    );
  }
}
